import React from 'react';
import {
  Grid,
  Box,
  IconButton,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { ArrowBackOutlined, ChevronRight } from '@material-ui/icons';
import { CustomizedTypography, CustomizedButton } from '@components/Customized';
import { useSignupStyle } from './styles';
import { useHistory, useParams } from 'react-router-dom';

const SignupTitleSection: React.FC = () => {
  const history = useHistory();
  const theme = useTheme();
  const { capaFriendsId } = useParams<{ capaFriendsId: string }>();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const { mobileNav, titleSection } = useSignupStyle();

  return matches ? (
    /* 모바일 버전 */
    <Box className={mobileNav}>
      <IconButton
        className="arrowBackIcon"
        onClick={() => {
          history.goBack();
        }}
      >
        <ArrowBackOutlined />
      </IconButton>
      <CustomizedTypography
        variant="body1"
        color="textPrimary"
        fontWeight="500"
      >
        회원가입
      </CustomizedTypography>
    </Box>
  ) : (
    /* 데스크탑 버전 */
    <Grid
      container
      direction="column"
      alignItems="center"
      className={titleSection}
    >
      {!capaFriendsId && (
        <Grid container className="loginButton">
          <CustomizedTypography
            variant="body1"
            fontWeight="500"
            className="subText"
          >
            이미 계정이 있다면?
          </CustomizedTypography>

          <CustomizedButton
            variant="text"
            size="large"
            disableElevation
            endIcon={<ChevronRight />}
            onClick={() => {
              history.push('/login');
            }}
          >
            바로 로그인하기
          </CustomizedButton>
        </Grid>
      )}

      <Grid
        container
        direction="row"
        justifyContent={matches ? 'space-between' : 'center'}
        alignItems="center"
        className="logoBox"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          className="textBox"
        >
          <Box display="flex" alignItems="center" className="mainText">
            {!capaFriendsId && (
              <IconButton
                className="arrowBackIcon"
                onClick={() => {
                  history.goBack();
                }}
              >
                <ArrowBackOutlined />
              </IconButton>
            )}
            <CustomizedTypography
              variant="h3"
              color="textPrimary"
              fontWeight="700"
            >
              회원가입
            </CustomizedTypography>
          </Box>
          <CustomizedTypography variant="body2" fontWeight="normal">
            캐파에 오신 것을 환영합니다.
          </CustomizedTypography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SignupTitleSection;
